module.exports = __webpack_public_path__ + "media/images/dividend/ic_cc_amex-d5816a4fe2ed3ba1741ed69d02638c9f.svg";